import CustomerClub from "components/customerClub/CustomerClub";
import ManagementSidebar from "components/common/ManagementSidebar";

function ClubPage() {
  return (
    <div className="d-flex">
      {/* <ManagementSidebar></ManagementSidebar> */}
      <CustomerClub />
    </div>
  );
}

export default ClubPage;
